<script setup lang="tsx">
import { ref } from 'vue'
import Multiselect from 'vue-multiselect'
import { RT_Avoid, RT_Exclude, RT_Preserve, RT_Reduce, RT_Share, RT_Unscored, type RiskTreatment } from '@/models/enums-generated'
import { getTreatmentText } from '@/services/utils'

const props = defineProps<{ class?: any }>()
const model = defineModel<RiskTreatment | undefined>({ required: true })

const options = ref<RiskTreatment[]>([RT_Unscored, RT_Preserve, RT_Share, RT_Reduce, RT_Avoid, RT_Exclude])
</script>

<template>
	<Multiselect
		:allow-empty="false"
		:class="props.class"
		:searchable="false"
		:show-labels="false"
		:use-teleport="true"
		:options="options"
		v-model="model"
		:custom-label="getTreatmentText"
		placeholder=""
	/>
</template>
